import * as React from 'react';

import ActivitiesSvg from '../../assets/activites.svg';

import styles from './onboarding-graphic-activities.module.css';

export class OnboardingGraphicActivities extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.activities}>
                <div className={styles.fade} />
                <ActivitiesSvg />
                <div className={styles.fade} />
            </div>
        );
    }
}
